module.exports = __webpack_public_path__ + "static/img/30.547afb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/30.jpg
// module id = DZLE
// module chunks = 1